import PageShell from "@/components/layout/PageShell";
import SearchWidget from "@/components/shared/SearchWidget";
import CityCard from "@/components/shared/CityCard";
import ProviderStrip from "@/components/shared/ProviderStrip";
import { CITIES } from "@/lib/data";

export default function Cities() {
  return (
    <PageShell>
      <section className="bg-[#0B2545] text-white pt-16 md:pt-24 pb-14 md:pb-20" data-testid="cities-hero">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="overline-light mb-6">Popular US cities · 10 markets</div>
          <h1 className="font-serif text-[9vw] md:text-[6vw] lg:text-[5vw] leading-[1.02] tracking-[-0.02em] text-white max-w-5xl">
            Rental options in the ten busiest US car rental markets.
          </h1>
          <p className="mt-8 text-white/85 text-lg md:text-xl leading-relaxed max-w-3xl">
            From LAX to LaGuardia, MCO to DFW — Carztohire compares every major provider at every
            major airport, plus dozens of downtown pickup locations.
          </p>
        </div>
        <div className="relative -mb-14 md:-mb-16 z-10 mt-10 md:mt-14 mx-auto max-w-[1600px] px-5 md:px-10">
          <SearchWidget variant="compact" />
        </div>
      </section>

      <div className="h-14 md:h-16 bg-white" />
      <ProviderStrip />

      <section className="py-20 md:py-28 bg-white">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {CITIES.map((c, i) => (
              <CityCard key={c.slug} city={c} index={i} />
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
